// extracted by mini-css-extract-plugin
module.exports = {"breakpoint-tablet":"(min-width: 520px)","location":"style-module--location--0b3b15","addressPart":"style-module--addressPart--484b23","chainLink":"style-module--chainLink--f69b50"};